import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AgreementsConnectorService, SemAgreementsConnectorService } from '@warema/shared/connector-services';
import { SnackbarService } from '@warema/shared/helpers';
import { AgreementDocument } from '@warema/shared/models';
import { SnackbarType } from '@warema/warema-ui';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AgreementsService {
    private readonly _snackbar = inject(SnackbarService);
    private readonly _agreementsConnectorService = inject(AgreementsConnectorService);
    private readonly _semAgreementsConnectorService = inject(SemAgreementsConnectorService);

    public getAgreementDocument(agreement: string): Promise<void | AgreementDocument> {
        return lastValueFrom(this._agreementsConnectorService.getDocument(agreement)).catch(
            (error: HttpErrorResponse) => {
                this._handleError(error);
            },
        );
    }

    public getSemAgreementDocument(
        consultationId: string,
        agreementKey: string,
        language: string,
    ): Promise<void | AgreementDocument> {
        return lastValueFrom(
            this._semAgreementsConnectorService.getAgreement(consultationId, agreementKey, language),
        ).catch((error: HttpErrorResponse) => {
            this._handleError(error);
        });
    }

    private _handleError(error: HttpErrorResponse): void {
        let text: string;
        if (error.status === 404) {
            text = 'AGREEMENTS_NOT_FOUND_ERROR';
        } else {
            text = 'SORRY_ERROR_OCCURRED';
        }
        void this._snackbar.showSnackbarTranslated({
            type: SnackbarType.Error,
            duration: 20000,
            text,
        });
    }
}
